// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JRY9n_226vN9ULc4_JcP{text-decoration:none}.PWNAcFoCD9eVUGREeb65{margin-top:24px;align-items:flex-start}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/international/ui/FinalDetails/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA,CAGF,sBACE,eAAA,CACA,sBAAA","sourcesContent":[".link {\n  text-decoration: none;\n}\n\n.declaration {\n  margin-top: 24px;\n  align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `JRY9n_226vN9ULc4_JcP`,
	"declaration": `PWNAcFoCD9eVUGREeb65`
};
export default ___CSS_LOADER_EXPORT___;
